import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm z-50 shadow-sm">
      <nav className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <h1 className="text-2xl font-bold text-blue-900">Gizeli Rodrigues</h1>
            <span className="text-sm text-blue-600 hidden sm:inline">Terapeuta</span>
          </div>

          {/* Desktop Menu */}
          <ul className="hidden md:flex items-center space-x-8">
            <li>
              <button
                onClick={() => scrollToSection('inicio')}
                className="text-gray-700 hover:text-blue-600 transition-colors duration-300 font-medium"
              >
                Início
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection('sobre')}
                className="text-gray-700 hover:text-blue-600 transition-colors duration-300 font-medium"
              >
                Quem Sou
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection('especialidades')}
                className="text-gray-700 hover:text-blue-600 transition-colors duration-300 font-medium"
              >
                Especialidades
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection('formacoes')}
                className="text-gray-700 hover:text-blue-600 transition-colors duration-300 font-medium"
              >
                Formações
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection('contato')}
                className="bg-blue-600 text-white px-6 py-2.5 rounded-full hover:bg-blue-700 transition-all duration-300 font-medium shadow-md hover:shadow-lg"
              >
                Agendar Sessão
              </button>
            </li>
          </ul>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-gray-700 p-2"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-200">
            <ul className="flex flex-col space-y-3 pt-4">
              <li>
                <button
                  onClick={() => scrollToSection('inicio')}
                  className="text-gray-700 hover:text-blue-600 transition-colors duration-300 font-medium w-full text-left"
                >
                  Início
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('sobre')}
                  className="text-gray-700 hover:text-blue-600 transition-colors duration-300 font-medium w-full text-left"
                >
                  Quem Sou
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('especialidades')}
                  className="text-gray-700 hover:text-blue-600 transition-colors duration-300 font-medium w-full text-left"
                >
                  Especialidades
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('formacoes')}
                  className="text-gray-700 hover:text-blue-600 transition-colors duration-300 font-medium w-full text-left"
                >
                  Formações
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contato')}
                  className="bg-blue-600 text-white px-6 py-2.5 rounded-full hover:bg-blue-700 transition-all duration-300 font-medium w-full"
                >
                  Agendar Sessão
                </button>
              </li>
            </ul>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;